<template>
  <div class="user-navigation-bar-item">
    <template v-if="profile.icon !== null && profile.icon.url !== ''">
      <img :src="profile.icon.url" class="icon-user" />
    </template>
    <template v-else>
      <img src="@/assets/image/no-image.png" class="icon-user" />
    </template>
    <div>
      <div
        v-if="profile.lastName === '' && profile.firstName === ''"
        class="name nodata"
      >
        {{ $t('名前が未入力です') }}
      </div>
      <div v-else class="name">
        {{ profile.lastName }}{{ profile.firstName }}
      </div>
      <div class="organization">{{ profile.organizationName }}</div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useUser } from '~/composables/user';
export default defineComponent({
  data() {
    const { profile } = useUser();
    return {
      profile
    };
  }
});
</script>
<style lang="scss" scoped>
.user-navigation-bar-item {
  color: #444;
  width: 100%;
  display: flex;
  position: relative;
  padding-right: 10px;

  .name {
    margin-top: 2px;
    font-weight: bold;
    font-size: 14px;
  }

  .name.nodata {
    opacity: 0.5;
    font-weight: normal;
  }

  .organization {
    margin-top: 4px;
    font-size: 12px;
  }

  img.icon-user {
    margin-right: 10px;
    width: 48px;
    height: 48px;
    object-fit: cover;
    border: 2px solid #fff;
    border-radius: 75px;
  }

  img.arrow {
    position: absolute;
    width: auto;
    height: 10px;
    top: calc(50% - 5px);
    right: 0;
  }
}
</style>
